import store from "../../store";
import { authActions, basketActions, configActions } from "../../actions";
import console from "./console";
import { decode, hasCrypto } from "./crypt";

const setData = (sessionStore) => {
  if (!sessionStore) return;
  const { configStorage } = store.getState();
  const dispatch = store.dispatch;
  const {
    header, kundenId, edelmetallWarenkorb, sortenWarenkorb, warenkorbId
  } = sessionStore;
  const angebotsNr = edelmetallWarenkorb ? edelmetallWarenkorb.angebotsNr : (sortenWarenkorb || {}).angebotsNr;

  dispatch(configActions.setTanAuth(header));
  dispatch(authActions.signIn(kundenId));
  dispatch(basketActions.setWarenkorbId(warenkorbId ? warenkorbId :angebotsNr));

  configStorage.setRequestHeader(header);
  localStorage.removeItem("tanRequested");
  localStorage.removeItem("kundenId");
  localStorage.removeItem("header");
  localStorage.removeItem("tanSessionStore");
};

// Stellt die Session wieder her, nachdem eine Bestellung über TAN extern authorisiert wurde
export const handleTanAuth = async () => {
  const { configStorage } = store.getState();
  let tanRequested = localStorage.getItem("tanRequested");
  const tanAuth = new URL(window.location).searchParams.get("tanAuth");
  if (tanRequested === "yes" && String(tanAuth).match(/^(true|yes|false|no)$/)) {
    //Aktuell notwendig, da die Daten nach dem Redirect aus configStorage alle verschwinden.
    if (hasCrypto()) {
      await decode(JSON.parse(localStorage.getItem("tanSessionStore")), configStorage.getAppId())
        .then(tanSessionStore => {
          console.debug("store", tanSessionStore);
          setData(JSON.parse(tanSessionStore));
        })
        .catch(e => {
          console.debug("no encrypted data", e);
          setData({
            header: localStorage.getItem("header"),
            kundenId: localStorage.getItem("kundenId"),
          });
        });
    } else {
      setData({
        header: localStorage.getItem("header"),
        kundenId: localStorage.getItem("kundenId"),
      });
    }
    return true;
  } else {
    localStorage.removeItem("tanRequested");
    return false;
  }
};
